import Vue from "vue";

import { getLedgerTransactions, getBalanceAccounts } from "@/api";
//
export default {
  namespaced: true,

  state: {
    depositAccounts: {},
    page: 1,
    limit: 50,
    sort: "-_id",
    searchString: "",
    valute: null,
    isFiltered: false,
    loading: true
  },

  mutations: {
    setDepositAccounts(state, depositAccounts) {
      state.depositAccounts = depositAccounts;
    },
    setPage(state, page) {
      state.page = page;
    },
    setSort(state, sort) {
      state.sort = sort;
    },
    setLimit(state, limit) {
      state.limit = limit;
    },
    setIsFiltered(state, isFiltered) {
      state.isFiltered = isFiltered;
    },
    setSearchString(state, searchString) {
      state.searchString = searchString;
    },
    setValute(state, valute) {
      state.valute = valute;
    },
    setLoading(state, loading) {
      state.loading = loading;
    }
  },

  actions: {
    async searchQueryBuilder(store) {
      if (!store.state.searchString && !store.state.valute) {
        store.commit("setIsFiltered", false);
        return {};
      }

      const queryBuilders = [
        {
          state: "searchString",
          builder: () => {
            const q = {
              $or: [
                {
                  title: {
                    $regex: `.*${store.state["searchString"]}.*`,
                    $options: "i"
                  }
                }
              ]
            };
            if (
              store.state["searchString"].length === 12 ||
              store.state["searchString"].length === 24
            )
              q["$or"].push({ _id: store.state["searchString"] });
            if (Number.isFinite(+store.state["searchString"]))
              q["$or"].push({
                balance: store.state["searchString"]
              });
            return q;
          }
        },
        {
          state: "valute",
          builder: () => {
            const q = {
              valute: store.state["valute"]
            };
            return q;
          }
        }
      ];
      const query = {
        $and: queryBuilders
          .filter(b => !!store.state[b.state])
          .map(b => b.builder())
      };

      store.commit("setIsFiltered", true);
      return query;
    },
    async getDepositAccounts(store, payload = {}) {
      store.commit("setLoading", true);
      // const resp = await getLedgerTransactions({
      //   page: store.state.page,
      //   limit: store.state.limit,
      //   sort: store.state.sort,
      //   query: { direction: "deposit_out" }
      // });
      const queryForSearch = await store.dispatch("searchQueryBuilder");
      const resp = await getBalanceAccounts({
        page: store.state.page,
        limit: store.state.limit,
        sort: store.state.sort,
        populate: "exchange",
        query: { $and: [{ is_deposit: true }, queryForSearch] }
      });
      if (resp.data.status) {
        const res = {
          ...resp.data.result,
          docs: resp.data.result.docs.map(doc => {
            return {
              ...doc,
              isNew: doc._id === payload.newId
            };
          })
        };
        store.commit("setDepositAccounts", res);
        store.commit("setLoading", false);
        return resp.data.result;
      }
    },
    async goToPage(store, payload) {
      if (
        payload.page &&
        store.state.depositAccounts.totalPages &&
        store.state.depositAccounts.totalPages >= payload.page
      ) {
        store.commit("setPage", payload.page);
        await store.dispatch("getDepositAccounts");
      }
    },
    async changeSorting(store, payload) {
      if (payload.sort !== undefined) {
        store.commit("setSort", payload.sort);
        await store.dispatch("getDepositAccounts");
      }
    },
    changeSearchString(store, payload) {
      if (payload.searchString !== undefined) {
        store.commit("setSearchString", payload.searchString);
      }
    },
    changeValute(store, payload) {
      if (payload.valute !== undefined) {
        store.commit("setValute", payload.valute);
      }
    },
    async performSearch(store, payload) {
      await store.dispatch("getDepositAccounts");
    },
    async resetSearch(store, payload) {
      store.commit("setSearchString", "");
      store.commit("setValute", null);
      await store.dispatch("getDepositAccounts");
    }

    // async addBalanceAccount(store, balanceAccount) {
    //   const resp = await addBalanceAccount(balanceAccount);
    //   if (resp.data.status) {
    //     await store.dispatch("getDepositAccounts", {
    //       newId: resp.data.result._id
    //     });
    //     return resp;
    //   }
    // }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/depositAccounts.js